import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import usePatchHook from "../../customHooks/usePatchHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import BranchIcon from "../../Icons/BranchIcon";
const BranchListComponent = loadable(
  () => import("../../components/Branch/BranchList")
);

const BranchList = () => {
  const { mutateAsync: patchUser } = usePatchHook({
    queryKey: ["branch"],
    navigateURL: null,
  });
  const handleIsEnableEmail = async (value: boolean, id: any) => {
    const payload = {
      is_enable_email: value,
    };
    const url = `${APIS.BRANCH}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsEnableSMS = async (value: boolean, id: any) => {
    const payload = {
      is_enable_sms: value,
    };
    const url = `${APIS.BRANCH}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.BRANCH}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <BranchIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Branch</span>
      </div>
      <BranchListComponent
        handleIsActive={handleIsActive}
        handleIsEnableEmail={handleIsEnableEmail}
        handleIsEnableSMS={handleIsEnableSMS}
      />
    </>
  );
};

export default BranchList;
